export default "__VITE_ASSET__CdUhyYcs__"